import React from "react";
import { createRoot } from "react-dom/client"; // Для React 18+
// import ReactDOM from 'react-dom'; // Для React < 18
import App from "./App"; // Убедитесь, что это путь к вашему улучшенному App.js
import "./styles.css"; // Импорт стилей

const container = document.getElementById("root");

// Для React 18+
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Для React < 18
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   container
// );